/** Factory that takes an array of unique values and maps them to an list of color values
 * save "badgeColorMap" to useAuthoringCommentsStore commentsColorMap var to use on multiple dispersed components
 * or use "Badge" on the same component that calls the hook
 */
import React from 'react'
import PropTypes from 'prop-types'
import { Badge as BadgeComp } from 'components-design-system'
import { colorSchemes } from "components-design-system/badges/Badge/Badge"

const useBadges = (uniqueValues, excludeColors = []) => {

  const badgeColorMap = React.useMemo(() => {
    let map = null
    const colors = colorSchemes.filter((color) => !excludeColors.includes(color))
    if (uniqueValues && Array.isArray(uniqueValues)) {
      map = {}
      let colorIndex = 0
      for (let i = 0; i < uniqueValues.length; i++) {
        map[uniqueValues[i]] = colors[colorIndex]
        colorIndex = colorIndex + 1 === colors.length ? 0 : colorIndex + 1
      }
      return map
    }
    return null
  }, [uniqueValues])

  const Badge = ({ value, ...props }) => {
    if (badgeColorMap) {
      return <BadgeComp
        value={value}
        colorName={badgeColorMap?.[value]}
        {...props}
      />
    }
    return null
  }

  return {
    badgeColorMap,
    Badge,
  }
}

useBadges.proptypes = {
  badgeColorMap: PropTypes.object,
  uniqueValues: PropTypes.arrayOf(PropTypes.string),
}

export default useBadges